export default "__VITE_ASSET__DlGgliLE__"